import { VIDEO_MIME_TYPES } from '@crehana/player';
var trailerTypeToMimeType = function trailerTypeToMimeType(videoSourceType) {
  return videoSourceType.toUpperCase().includes('HLS') ? VIDEO_MIME_TYPES.HLS : VIDEO_MIME_TYPES.MP4;
};
export default trailerTypeToMimeType;